const tandc = {
  EN: {
    header: 'Term and Condition',
    policy: 'Privacy Policy for Customer',
    policy_content:
      'Toneer company limited recognizes the importance of the protection of your personal data. This Privacy Policy explains our practices regarding the collection, use or disclosure of personal data including other rights of the Data Subjects in accordance with the Personal Data Protection Laws.',
    collection: 'Collection of Personal Data',
    collection_content:
      'We will collect your personal data that receive directly from you as following:',
    collection_list: {
      1: 'your account registration',
      2: 'telephone',
      3: 'email address',
    },
    data_collect: 'Types of Data Collected',
    data_type: {
      1: {
        head: 'Personal data',
        con: 'such as name, surname, age, date of birth, nationality, identification card, passport, etc.',
      },
      2: {
        head: 'Contact information',
        con: 'such as address, telephone number, e-mail address, etc',
      },
      3: {
        head: 'Account details',
        con: 'such as username, password, transactions history, etc.',
      },
      4: {
        head: 'Proof of identity',
        con: 'such as copy of identification card, copy of passport, etc.',
      },
      5: {
        head: 'Transaction and Financial information',
        con: 'such as purchase history, credit card details, bank account, etc.',
      },
      6: {
        head: 'Technical data',
        con: 'such as IP address, Cookie ID, Activity Log, etc.',
      },
      7: {
        head: 'Other',
        con: 'such as photo, video, and other information that is considered personal data under the Personal Data Protection Laws.',
      },
    },
    data_content: {
      1: 'We may collect, use or disclose your sensitive data that is specially categorized by law when we have obtained explicit consent from you or where necessary for us as permissible under law. We may collect, use or disclose your sensitive personal data as following:',
      2: 'Any data which may affect the data subject in the same manner, as prescribed by the Personal Data Protection Committee.',
    },
    data_list: {
      1: 'racial',
      2: 'ethnic',
      3: 'political opinions',
      4: 'cult',
      5: 'religious or philosophical beliefs',
      6: 'sexual behavior',
      7: 'health data',
      8: 'disability',
    },
    children: 'Children',
    children_content:
      'If you are under the age of 20 or having legal restrictions, we may collect use or disclose your personal data. We require your parents or guardian to be aware and provide consent to us or allowed by applicable laws. If we become aware that we have collected personal data from children without verification of parental consent, we take steps to remove that information from our servers.',
    storage: 'Storage of Data',
    storage_content: {
      1: 'We store your personal data as hard copy and soft copy.',
      2: 'We store your personal data by using the following systems:',
      3: 'Third-party server service providers outside of Thailand',
    },
    use: 'Use of Data',
    use_content: 'We use the collected data for various purposes:',
    use_list: {
      1: 'To create and manage accounts',
      2: 'To provide products or services',
      3: 'To improve products, services, or user experiences',
      4: 'To share and manage information within organization',
      5: 'To conduct marketing activities and promotions',
      6: 'To provide after-sales services',
      7: 'To gather user’s feedback',
      8: 'To process payments of products or services',
      9: 'To comply with our Terms and Conditions',
      10: 'To comply with laws, rules, and regulatory authorities',
    },
    disclosure: {
      head: 'Disclosure of Personal Data',
      con: 'We may disclose your personal data to the following parties in certain circumstances:',
      1: {
        head: 'Organization',
        con: 'We may disclose your personal data within our organization to provide and develop our products or services. We may combine information internally across the different products or services covered by this Privacy Policy to help us be more relevant and useful to you and others.',
      },
      2: {
        head: 'Service Providers',
        con: 'We may use service providers to help us provide our services such as payments, marketing and development of products or services. Please note that service providers have their own privacy policy.',
      },
      3: {
        head: 'Business Partners',
        con: 'In relation with our business partners, we may disclose certain personal data to them in order to coordinate and provide our products or services to you and provide necessary information about the availability of our products or services.',
      },
      4: {
        head: 'Law Enforcement',
        con: 'Under certain circumstances, we may be required to disclose your personal data if required to do so by law or in response to valid requests by government authority such as courts, government authorities.',
      },
      5: {
        head: 'Cross-Border Data Transfer',
        con: 'We may disclose or transfer your personal data to third parties, organizations or servers located in foreign countries. We will take steps and measures to ensure that your personal data is securely transferred, and the receiving parties have an appropriate level of personal data protection standard or as allowed by laws.',
      },
    },
    data_retention: {
      head: 'Data Retention',
      con: 'We will retain your personal data for as long as necessary during the period you are a customer or under relationship with us, or for as long as necessary in connection with the purposes set out in this Privacy Policy, unless law requires or permits a longer retention period. We will erase, destroy or anonymize your personal data when it is no longer necessary or when the period lapses.',
    },
    data_subject: {
      head: 'Data Subject Rights',
      con1: 'Subject to the Personal Data Protection Laws thereof, you may exercise any of these rights in the following:',
      con2: 'You can exercise these rights as the Data Subject by contacting our Data Protection Officer as mentioned below. We will notify the result of your request within 30 days upon receipt of such request. If we deny the request, we will inform you of the reason via SMS, email address, telephone, registered mail (if applicable).',
      1: {
        head: 'Withdrawal of consent',
        con: ': If you have given consent to us to collect, use or disclose your personal data whether before or after the effective date of the Personal Data Protection Laws, you have the right to withdraw such consent at any time throughout the period your personal data available to us, unless it is restricted by laws or you are still under beneficial contract.',
      },
      2: {
        head: 'Data access',
        con: ': You have the right to access your personal data that is under our responsibility; to request us to make a copy of such data for you; and to request us to reveal as to how we obtain your personal data.',
      },
      3: {
        head: 'Data portability',
        con: ': You have the right to obtain your personal data if we organize such personal data in automatic machine-readable or usable format and can be processed or disclosed by automatic means; to request us to send or transfer the personal data in such format directly to other data controllers if doable by automatic means; and to request to obtain the personal data in such format sent or transferred by us directly to other data controller unless not technically feasible.',
      },
      4: {
        head: 'Objection',
        con: ': You have the right to object to collection, use or disclosure of your personal data at any time if such doing is conducted for legitimate interests of us, corporation or individual which is within your reasonable expectation; or for carrying out public tasks.',
      },
      5: {
        head: 'Data erasure or destruction',
        con: ': You have the right to request us to erase, destroy or anonymize your personal data if you believe that the collection, use or disclosure of your personal data is against relevant laws; or retention of the data by us is no longer necessary in connection with related purposes under this Privacy Policy; or when you request to withdraw your consent or to object to the processing as earlier described.',
      },
      6: {
        head: 'Suspension',
        con: ': You have the right to request us to suspend processing your personal data during the period where we examine your rectification or objection request; or when it is no longer necessary and we must erase or destroy your personal data pursuant to relevant laws but you instead request us to suspend the processing.',
      },
      7: {
        head: 'Rectification',
        con: ': You have the right to rectify your personal data to be updated, complete and not misleading.',
      },
      8: {
        head: 'Complaint lodging',
        con: ': You have the right to complain to competent authorities pursuant to relevant laws if you believe that the collection, use or disclosure of your personal data is violating or not in compliance with relevant laws.',
      },
    },
    advertising: {
      head: 'Advertising and Marketing',
      con: 'We may send certain information or newsletter for the purpose of utilizing your preference via your email. If you no longer want to receive the communications from us, you can click the "unsubscribe" link in the email or contact us through our email.',
    },
    data_secure: {
      head: 'Data Security',
      con: 'We endeavor to protect your personal data by establishing security measures in accordance with the principles of confidentiality, integrity, and availability to prevent loss, unauthorized or unlawful access, destruction, use, alteration, or disclosure including administrative safeguard, technical safeguard, physical safeguard and access controls.',
    },
    data_breach: {
      head: 'Data Breach Notification',
      con: 'We will notify the Office of the Personal Data Protection Committee without delay and, where feasible, within 72 hours after having become aware of it, unless such personal data breach is unlikely to result in a risk to the rights and freedoms of you. If the personal data breach is likely to result in a high risk to the rights and freedoms of you, we will also notify the personal data breach and the remedial measures to you without delay through our website, SMS, email address, telephone or registered mail (if applicable).',
    },
    changes_policy: {
      head: 'Changes to this Privacy Policy',
      con1: 'We may change this Privacy Policy from time to time. Any changes of this Privacy Policy, we encourage you to frequently check on our website.',
      con2: 'This Privacy Policy was last updated and effective on 18th September 2021',
    },
    link_other: {
      head: 'Links to Other Sites',
      con: 'The purpose of this Privacy Policy is to offer products or services and use of our website. Any websites from other domains found on our site is subject to their privacy policy which is not related to us.',
    },
    contact: {
      head: 'Contact Information',
      con: 'If you have any questions about this Privacy Policy or would like to exercise your rights, you can contact us by using the following details:',
      1: {
        head: 'Data Controller',
        con1: 'Toneer',
        con2: '88/188 Thetsaban songkhro road, Lat Yao, Chatuchak, Bangkok, 10900',
        con3: 'oratai@toneer.co.th',
        con4: 'www.keyspace.tech',
        con5: '02-1214645',
      },
      2: {
        head: 'Data Protection Officer',
        con1: 'DTO team',
        con2: '88/188 Thetsaban songkhro road, Lat Yao, Chatuchak, Bangkok, 10900',
        con3: 'dto@toneer.co.th',
        con4: '02-1214645',
      },
    },
  },
  TH: {
    header: 'ข้อตกลงและเงื่อนไขการใช้บริการ',
    policy: 'นโยบายความเป็นส่วนตัวสำหรับลูกค้า',
    policy_content:
      'บริษัท ทูเนียร์ จำกัด ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของคุณ โดยนโยบายความเป็นส่วนตัวฉบับนี้ได้อธิบายแนวปฏิบัติเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิต่าง ๆ ของเจ้าของข้อมูลส่วนบุคคล ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล',
    collection: 'การเก็บรวบรวมข้อมูลส่วนบุคคล',
    collection_content:
      'เราจะเก็บรวบรวมข้อมูลส่วนบุคคลที่ได้รับโดยตรงจากคุณผ่านช่องทาง ดังต่อไปนี้',
    collection_list: {
      1: 'การสมัครสมาชิก',
      2: 'โทรศัพท์',
      3: 'อีเมล',
    },
    data_collect: 'ประเภทข้อมูลส่วนบุคคลที่เก็บรวบรวม',
    data_type: {
      1: {
        head: 'ข้อมูลส่วนบุคคล',
        con: 'เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด สัญชาติ เลขประจำตัวประชาชน หนังสือเดินทาง เป็นต้น',
      },
      2: {
        head: 'ข้อมูลการติดต่อ',
        con: 'เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล เป็นต้น',
      },
      3: {
        head: 'ข้อมูลบัญชี',
        con: 'เช่น บัญชีผู้ใช้งาน ประวัติการใช้งาน เป็นต้น',
      },
      4: {
        head: 'หลักฐานแสดงตัวตน',
        con: 'เช่น สำเนาบัตรประจำตัวประชาชน สำเนาหนังสือเดินทาง เป็นต้น',
      },
      5: {
        head: 'ข้อมูลการทำธุรกรรมและการเงิน',
        con: 'เช่น ประวัติการสั่งซื้อ รายละเอียดบัตรเครดิต บัญชีธนาคาร เป็นต้น',
      },
      6: {
        head: 'ข้อมูลทางเทคนิค',
        con: 'เช่น IP address, Cookie ID, ประวัติการใช้งานเว็บไซต์ (Activity Log) เป็นต้น',
      },
      7: {
        head: 'ข้อมูลอื่น ๆ',
        con: ' เช่น รูปภาพ ภาพเคลื่อนไหว และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล',
      },
    },
    data_content: {
      1: 'เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลอ่อนไหว ดังต่อไปนี้ เมื่อเราได้รับความยินยอมโดยชัดแจ้งจากคุณ เว้นแต่กฎหมายกำหนดให้ทำได้',
      2: 'ข้อมูลอื่นใดที่กระทบต่อข้อมูลส่วนบุคคลของคุณตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด',
    },
    data_list: {
      1: 'เชื้อชาติ',
      2: 'เผ่าพันธุ์',
      3: 'ความคิดเห็นทางการเมือง',
      4: 'ความเชื่อในลัทธิ',
      5: 'ศาสนาหรือปรัชญา',
      6: 'ประวัติอาชญากรรม',
      7: 'ความพิการ',
      8: 'ข้อมูลสหภาพแรงงาน',
    },
    children: 'ผู้เยาว์',
    children_content:
      'หากคุณมีอายุต่ำกว่า 20 ปีหรือมีข้อจำกัดความสามารถตามกฎหมาย เราอาจเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ เราอาจจำเป็นต้องให้พ่อแม่หรือผู้ปกครองของคุณให้ความยินยอมหรือที่กฎหมายอนุญาตให้ทำได้ หากเราทราบว่ามีการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้เยาว์โดยไม่ได้รับความยินยอมจากพ่อแม่หรือผู้ปกครอง เราจะดำเนินการลบข้อมูลนั้นออกจากเซิร์ฟเวอร์ของเรา',
    storage: 'วิธีการเก็บรักษาข้อมูลส่วนบุคคล',
    storage_content: {
      1: 'เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณในรูปแบบเอกสารและรูปแบบอิเล็กทรอนิกส์',
      2: 'เราเก็บรักษาข้อมูลส่วนบุคคลของคุณ ดังต่อไปนี้',
      3: 'ผู้ให้บริการเซิร์ฟเวอร์ในต่างประเทศ',
    },
    use: 'การประมวลผลข้อมูลส่วนบุคคล',
    use_content: 'เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้',
    use_list: {
      1: 'เพื่อสร้างและจัดการบัญชีผู้ใช้งาน',
      2: 'เพื่อจัดส่งสินค้าหรือบริการ',
      3: 'เพื่อปรับปรุงสินค้า บริการ หรือประสบการณ์การใช้งาน',
      4: 'เพื่อการบริหารจัดการภายในบริษัท',
      5: 'เพื่อการตลาดและการส่งเสริมการขาย',
      6: 'เพื่อการบริการหลังการขาย',
      7: 'เพื่อรวบรวมข้อเสนอแนะ',
      8: 'เพื่อชำระค่าสินค้าหรือบริการ',
      9: 'เพื่อปฏิบัติตามข้อตกลงและเงื่อนไข (Terms and Conditions)',
      10: 'เพื่อปฏิบัติตามกฎหมายและกฎระเบียบของหน่วยงานราชการ',
    },
    disclosure: {
      head: 'การเปิดเผยข้อมูลส่วนบุคคล',
      con: 'เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่ผู้อื่นภายใต้ความยินยอมของคุณหรือที่กฎหมายอนุญาตให้เปิดเผยได้ ดังต่อไปนี้',
      1: {
        head: 'การบริหารจัดการภายในองค์กร',
        con: 'เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณภายในบริษัทเท่าที่จำเป็นเพื่อปรับปรุงและพัฒนาสินค้าหรือบริการของเรา เราอาจรวบรวมข้อมูลภายในสำหรับสินค้าหรือบริการต่าง ๆ ภายใต้นโยบายนี้เพื่อประโยชน์ของคุณและผู้อื่นมากขึ้น',
      },
      2: {
        head: 'ผู้ให้บริการ',
        con: 'เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณบางอย่างให้กับผู้ให้บริการของเราเท่าที่จำเป็นเพื่อดำเนินงานในด้านต่าง ๆ เช่น การชำระเงิน การตลาด การพัฒนาสินค้าหรือบริการ เป็นต้น ทั้งนี้ ผู้ให้บริการมีนโยบายความเป็นส่วนตัวของตนเอง',
      },
      3: {
        head: 'พันธมิตรทางธุรกิจ',
        con: 'เราอาจเปิดเผยข้อมูลบางอย่างกับพันธมิตรทางธุรกิจเพื่อติดต่อและประสานงานในการให้บริการสินค้าหรือบริการ และให้ข้อมูลเท่าที่จำเป็นเกี่ยวกับความพร้อมใช้งานของสินค้าหรือบริการ',
      },
      4: {
        head: 'การบังคับใช้กฎหมาย',
        con: 'ในกรณีที่มีกฎหมายหรือหน่วยงานราชการร้องขอ เราจะเปิดเผยข้อมูลส่วนบุคคลของคุณเท่าที่จำเป็นให้แก่หน่วยงานราชการ เช่น ศาล หน่วยงานราชการ เป็นต้น',
      },
      5: {
        head: 'การโอนข้อมูลส่วนบุคคลไปต่างประเทศ',
        con: 'เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคล องค์กร หรือเซิร์ฟเวอร์ (Server) ที่ตั้งอยู่ในต่างประเทศ โดยเราจะดำเนินการตามมาตรการต่าง ๆ เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของคุณไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด',
      },
    },
    data_retention: {
      head: 'ระยะเวลาจัดเก็บข้อมูลส่วนบุคคล',
      con: 'เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณไว้ตามระยะเวลาที่จำเป็นในระหว่างที่คุณเป็นลูกค้าหรือมีความสัมพันธ์อยู่กับเราหรือตลอดระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวข้องกับนโยบายฉบับนี้ ซึ่งอาจจำเป็นต้องเก็บรักษาไว้ต่อไปภายหลังจากนั้น หากมีกฎหมายกำหนดไว้ เราจะลบ ทำลาย หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวตนของคุณได้ เมื่อหมดความจำเป็นหรือสิ้นสุดระยะเวลาดังกล่าว',
    },
    data_subject: {
      head: 'สิทธิของเจ้าของข้อมูลส่วนบุคคล',
      con1: 'ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล  คุณมีสิทธิในการดำเนินการดังต่อไปนี้',
      con2: 'คุณสามารถใช้สิทธิของคุณในฐานะเจ้าของข้อมูลส่วนบุคคลข้างต้นได้ โดยติดต่อมาที่เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราตามรายละเอียดท้ายนโยบายนี้ เราจะแจ้งผลการดำเนินการภายในระยะเวลา 30 วัน นับแต่วันที่เราได้รับคำขอใช้สิทธิจากคุณ ตามแบบฟอร์มหรือวิธีการที่เรากำหนด ทั้งนี้ หากเราปฏิเสธคำขอเราจะแจ้งเหตุผลของการปฏิเสธให้คุณทราบผ่านช่องทางต่าง ๆ เช่น ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น',
      1: {
        head: 'สิทธิขอถอนความยินยอม (right to withdraw consent)',
        con: ' หากคุณได้ให้ความยินยอม เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ ไม่ว่าจะเป็นความยินยอมที่คุณให้ไว้ก่อนวันที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลใช้บังคับหรือหลังจากนั้น คุณมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้ตลอดเวลา',
      },
      2: {
        head: 'สิทธิขอเข้าถึงข้อมูล (right to access)',
        con: ' คุณมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของคุณที่อยู่ในความรับผิดชอบของเราและขอให้เราทำสำเนาข้อมูลดังกล่าวให้แก่คุณ  รวมถึงขอให้เราเปิดเผยว่าเราได้ข้อมูลส่วนบุคคลของคุณมาได้อย่างไร',
      },
      3: {
        head: 'สิทธิขอถ่ายโอนข้อมูล (right to data portability)',
        con: ' คุณมีสิทธิขอรับข้อมูลส่วนบุคคลของคุณในกรณีที่เราได้จัดทำข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบให้สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิขอให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติ และมีสิทธิขอรับข้อมูลส่วนบุคคลที่เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค',
      },
      4: {
        head: 'สิทธิขอคัดค้าน (right to object)',
        con: ' คุณมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณในเวลาใดก็ได้ หากการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณที่ทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น โดยไม่เกินขอบเขตที่คุณสามารถคาดหมายได้อย่างสมเหตุสมผลหรือเพื่อดำเนินการตามภารกิจเพื่อสาธารณประโยชน์',
      },
      5: {
        head: 'สิทธิขอให้ลบหรือทำลายข้อมูล (right to erasure/destruction)',
        con: ' คุณมีสิทธิขอลบหรือทำลายข้อมูลส่วนบุคคลของคุณหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวคุณได้ หากคุณเชื่อว่าข้อมูลส่วนบุคคลของคุณถูกเก็บรวบรวม ใช้ หรือเปิดเผยโดยไม่ชอบด้วยกฎหมายที่เกี่ยวข้องหรือเห็นว่าเราหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้ หรือเมื่อคุณได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่แจ้งไว้ข้างต้นแล้ว',
      },
      6: {
        head: 'สิทธิขอให้ระงับการใช้ข้อมูล (right to restriction of processing)',
        con: ' คุณมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลชั่วคราวในกรณีที่เราอยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิขอแก้ไขข้อมูลส่วนบุคคลหรือขอคัดค้านของคุณหรือกรณีอื่นใดที่เราหมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของคุณตามกฎหมายที่เกี่ยวข้องแต่คุณขอให้เราระงับการใช้แทน',
      },
      7: {
        head: 'สิทธิขอให้แก้ไขข้อมูล (right to rectification)',
        con: ' คุณมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของคุณให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด',
      },
      8: {
        head: 'สิทธิร้องเรียน (right to lodge a complaint)',
        con: ' คุณมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง หากคุณเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง',
      },
    },
    advertising: {
      head: 'การโฆษณาและการตลาด',
      con: 'เราอาจส่งข้อมูลหรือจดหมายข่าวไปยังอีเมลของคุณ โดยมีวัตถุประสงค์เพื่อเสนอสิ่งที่น่าสนกับคุณ หากคุณไม่ต้องการรับการติดต่อสื่อสารจากเราผ่านทางอีเมลอีกต่อไป คุณสามารถกด "ยกเลิกการติดต่อ" ในลิงก์อีเมลหรือติดต่อมายังอีเมลของเราได้',
    },
    data_secure: {
      head: 'การรักษาความมั่งคงปลอดภัยของข้อมูลส่วนบุคคล',
      con: 'เราจะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของคุณไว้ตามหลักการ การรักษาความลับ (confidentiality) ความถูกต้องครบถ้วน (integrity) และสภาพพร้อมใช้งาน (availability) ทั้งนี้ เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย นอกจากนี้เราจะจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard) ในเรื่องการเข้าถึงหรือควบคุมการใช้งานข้อมูลส่วนบุคคล (access control)',
    },
    data_breach: {
      head: 'การแจ้งเหตุละเมิดข้อมูลส่วนบุคคล',
      con: 'ในกรณีที่มีเหตุละเมิดข้อมูลส่วนบุคคลของคุณเกิดขึ้น เราจะแจ้งให้สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลทราบโดยไม่ชักช้าภายใน 72 ชั่วโมง นับแต่ทราบเหตุเท่าที่สามารถกระทำได้ ในกรณีที่การละเมิดมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของคุณ เราจะแจ้งการละเมิดให้คุณทราบพร้อมกับแนวทางการเยียวยาโดยไม่ชักช้าผ่านช่องทางต่าง ๆ เช่น  เว็บไซต์ ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น',
    },
    changes_policy: {
      head: 'การแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัว',
      con1: 'เราอาจแก้ไขเปลี่ยนแปลงนโยบายนี้เป็นครั้งคราว โดยคุณสามารถทราบข้อกำหนดและเงื่อนไขนโยบายที่มีการแก้ไขเปลี่ยนแปลงนี้ได้ผ่านทางเว็บไซต์ของเรา',
      con2: 'นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 18 กันยายน 2564',
    },
    link_other: {
      head: 'นโยบายความเป็นส่วนตัวของเว็บไซต์อื่น',
      con: 'นโยบายความเป็นส่วนตัวฉบับนี้ใช้สำหรับการเสนอสินค้า บริการ และการใช้งานบนเว็บไซต์สำหรับลูกค้าของเราเท่านั้น หากคุณเข้าชมเว็บไซต์อื่นแม้จะผ่านช่องทางเว็บไซต์ของเรา การคุ้มครองข้อมูลส่วนบุคคลต่าง ๆ จะเป็นไปตามนโยบายความเป็นส่วนตัวของเว็บไซต์นั้น ซึ่งเราไม่มีส่วนเกี่ยวข้องด้วย',
    },
    contact: {
      head: 'รายละเอียดการติดต่อ',
      con: 'หากคุณต้องการสอบถามข้อมูลเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้ รวมถึงการขอใช้สิทธิต่าง ๆ คุณสามารถติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราได้ ดังนี้',
      1: {
        head: 'ผู้ควบคุมข้อมูลส่วนบุคคล',
        con1: 'บริษัท ทูเนียร์ จำกัด',
        con2: '88/188 ถนนเทศบาลสงเคราะห์ ลาดยาว จตุจักร กรุงเทพมหานคร 10900',
        con3: 'อีเมล oratai@toneer.co.th',
        con4: 'เว็บไซต์ www.keyspace.tech',
        con5: 'หมายเลขโทรศัพท์ 02-1214645',
      },
      2: {
        head: 'เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล',
        con1: 'ทีม DTO',
        con2: '88/188 ถนนเทศบาลสงเคราะห์ ลาดยาว จตุจักร กรุงเทพมหานคร 10900',
        con3: 'อีเมล finance@toneer.co.th',
        con4: 'หมายเลขโทรศัพท์ 02-1214645',
      },
    },
  },
};

export default tandc;
